// extracted by mini-css-extract-plugin
export var screen2 = "screen2-module--screen2--4a0a0";
export var screen2__list = "screen2-module--screen2__list--b14a4";
export var screen2__listItem = "screen2-module--screen2__list-item--0aa74";
export var screen2__listText = "screen2-module--screen2__list-text--42e16";
export var screen2__text = "screen2-module--screen2__text--ba222";
export var screen2__textOrange = "screen2-module--screen2__text-orange--ac503";
export var video__content = "screen2-module--video__content--4bda8";
export var video__content_iframe = "screen2-module--video__content_iframe--b32df";
export var video__screencastWrapper = "screen2-module--video__screencast-wrapper--33470";
export var video__text = "screen2-module--video__text--86fd5";